import Vue from 'vue'
import App from './App'
import VueSweetAlert from 'vue-sweetalert';
import router from './router';
import axios from 'axios';
import store from './store';
import FullCalendar from 'vue-full-calendar';
import moment from 'moment';
import VueTippy from 'vue-tippy';

Vue.config.productionTip = false;

//Add Full-Calendar
Vue.use(FullCalendar);

//Add sweet alert
Vue.use(VueSweetAlert);

//add tippy tooltips
Vue.use(VueTippy);

//add moment js! for date and times
Vue.prototype.moment = moment

window.downloadFile = function (fileUrl) {

    var a = document.createElement('A');
    a.href = fileUrl;
    a.download = fileUrl.substr(fileUrl.lastIndexOf('/') + 1);
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
};


new Vue({
            render: h => h(App),
            router,
            store,
        }).$mount('#app');

//add progress to axios
axios.interceptors.request.use(function (config) {
    if(typeof app.$Progress !=='undefined'){
        app.$Progress.start()
        app.$Progress.finish()
    }
    return config;
}, function (error) {
    // Do something with request error
    return Promise.reject(error);
});
